import {
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import MySelect from "../../../components/MySelect";
import boxStyles from "../../../styles/boxStyles";
import fieldStyles from "../../../styles/fieldStyles";
import { components } from "react-select";
import makeAnimated from "react-select/animated";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const MultiValue = (props) => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const animatedComponents = makeAnimated();

const PotensiOutcome = () => {
  const [selectPotensiKerugianId, setSelectPotensiKerugianId] = useState([]);

  const potensiKerugian = [
    { key: "1", value: "Manusia" },
    { key: "2", value: "Lingkungan" },
    { key: "3", value: "Property/Aset" },
    { key: "4", value: "Reputasi" },
  ];

  const handleChange = (event) => {
    const { value } = event.target;

    setSelectPotensiKerugianId(value);
  };

  return (
    <div>
      <Box component="div" sx={boxStyles}>
        <center>
          <h3
            style={{
              color: "black",
            }}
          >
            POTENSI OUTCOME *)
          </h3>
        </center>

        <Stack direction="column" sx={fieldStyles}>
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ display: "flex" }}
          >
            <FormControl sx={{ maxWidth: "30%", width: "30%" }}>
              <FormLabel id="demo-multiple-checkbox-label">
                Potensi Jenis Kerugian
              </FormLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectPotensiKerugianId}
                onChange={handleChange}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((kerugianId) => (
                      <Chip
                        key={kerugianId}
                        label={
                          potensiKerugian?.find((e) => e.key === kerugianId)
                            .value
                        }
                      />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {potensiKerugian.map((item) => (
                  <MenuItem key={item.key} value={item.key}>
                    <Checkbox
                      checked={selectPotensiKerugianId.indexOf(item.key) > -1}
                    />
                    <ListItemText primary={item.value} />
                  </MenuItem>
                ))}
              </Select>

              {/* <FormLabel id="radio1">Potensi Jenis Kerugian</FormLabel>

            <MySelect
              options={potensiKerugian}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option, MultiValue, animatedComponents }}
              onChange={(e) => setOptionPotensiKerugian(e)}
              allowSelectAll={true}
              value={optionPotensiKerugian}
            /> */}
            </FormControl>
            <FormControl>
              <FormLabel id="radio1">Potensi tingkat Keparahan</FormLabel>
              <RadioGroup
                row
                aria-labelledby="radio1"
                name="row-radio-buttons-group"
              >
                <FormControlLabel value="1" control={<Radio />} label="In" />
                <FormControlLabel value="2" control={<Radio />} label="Mn" />
                <FormControlLabel value="3" control={<Radio />} label="Md" />
                <FormControlLabel value="4" control={<Radio />} label="Si" />
                <FormControlLabel value="5" control={<Radio />} label="C" />
              </RadioGroup>
            </FormControl>
            <FormControl>
              <FormLabel id="radio1">Probabilitas Kejadian</FormLabel>
              <RadioGroup
                row
                aria-labelledby="radio1"
                name="row-radio-buttons-group"
              >
                <FormControlLabel value="1" control={<Radio />} label="1" />
                <FormControlLabel value="2" control={<Radio />} label="2" />
                <FormControlLabel value="3" control={<Radio />} label="3" />
                <FormControlLabel value="4" control={<Radio />} label="4" />
                <FormControlLabel value="5" control={<Radio />} label="5" />
              </RadioGroup>
            </FormControl>
          </Stack>

          <Stack>
            <br></br>
            <Box>
              <TextField
                name="text1"
                label="Keterangan Potensi Kerugian"
                variant="outlined"
                fullWidth
                // value={input}
                // onChange={(e) => setInput(e.target.value)}
              />

              <p style={{ color: "red" }}>
                <small>
                  <i>
                    Keterangan*) Sesuai Pedoman Pengelolaan HSSE Berbasis Resiko
                  </i>
                </small>
              </p>
            </Box>
          </Stack>
        </Stack>
      </Box>
    </div>
  );
};

export default PotensiOutcome;
